import { Component, OnInit, HostListener, ViewChild, Output, Input, ElementRef, EventEmitter } from '@angular/core';
import { ThemeService } from '../theme.service';
import { BaseComponent } from '../classes/BaseComponent';

@Component({
  selector: 'app-multichoice-menu',
  templateUrl: './multichoice-menu.component.html',
  styleUrls: ['./multichoice-menu.component.scss']
})
export class MultichoiceMenuComponent extends BaseComponent implements OnInit {

  @Input() title = "";
  @Input() label = "";
  @Input() right: boolean = false;
  @Input() alignLeft: boolean = false;

  private _selectedItemsList: Array<CustomMap> = [];

  @Input() set selectedItemsList(value: Array<CustomMap>) {
    this._selectedItemsList = value;
  }

  get selectedItemsList(): Array<CustomMap> {
    return this._selectedItemsList;
  }

  itemListToDisplay: CustomMap[] = [];
  // list of all the items, including the selected
  private _itemList: CustomMap[] = [];
  @Input() set itemList(value: CustomMap[]) {
    if(value) {
      this._itemList = value;
      this.itemListToDisplay = this._itemList.slice(1);
    }
  }
  get itemList(): CustomMap[] {
    return this._itemList;
  }

  @Output() selectionChanged = new EventEmitter();

  public elementRef;
  @ViewChild('dropdownContent', {static: false}) dropdownContent;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!event || !event.target) {
      return;
    }
    try {
      if (this.elementRef && this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(event.target)) {
        // Safely check className - handle cross-origin iframe elements
        let classNameString = '';
        try {
          const className = event.target.className;
          if (className) {
            if (typeof className === 'string') {
              classNameString = className;
            } else if (className && typeof className === 'object') {
              if (className.baseVal !== undefined) {
                classNameString = className.baseVal || '';
              } else if (typeof className.toString === 'function') {
                classNameString = className.toString();
              }
            }
          }
        } catch (e) {
          // Permission denied when accessing className from cross-origin iframe - ignore
          return;
        }
        if (classNameString != "item") {
          this.closeDropdown();
        }
      }
    } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
    }
  }

  constructor(
    myElement: ElementRef,
    private themeService: ThemeService
  ) {
    super();
    this.elementRef = myElement;
   }

  ngOnInit() {
  }

  shouldBeRed(): boolean {
    if(!this.itemList[0] || !this.selectedItemsList[0]) {
      return false;
    }
    return this.selectedItemsList[0].key != this.itemList[0].key;
  }

  isSelected(item): boolean {
    if(!item) { return false; }
    return this.selectedItemsList.filter(el => el.key == item.key).length > 0;
  }

  isOpen(): boolean {
    return this.dropdownContent && this.dropdownContent.nativeElement && this.dropdownContent.nativeElement.classList.contains("dd-open");
  }

  dropdownClick() {

    if (this.isOpen()) {
      this.closeDropdown();
    }
    else {
      this.openDropdown();
    }
  }

  openDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-open";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
    }
  }

  closeDropdown() {
    if (this.dropdownContent && this.dropdownContent.nativeElement) {
      let className = "dropdown-content dd-close";
      if (this.right) {
        className += " right";
      }
      this.dropdownContent.nativeElement.className = className;
    }
  }

  getDownTriangleSrc(): string {
    return this.themeService.isDarkTheme() ? "./assets/images/white_down_triangle.png" : "./assets/images/black_down_triangle.png";
  }

  getSelection(): string {

    const selection = [];
    if(this._selectedItemsList && this._selectedItemsList[0]) {
      selection.push(this._selectedItemsList[0].value);
    }
    let selectionString = selection.join();
    const count = this._selectedItemsList ? this._selectedItemsList.length : 0;
    if(selectionString.length > 11) {
      selectionString = selectionString.substr(0, 11) + "...";
    }

    if(count > 1) {
      selectionString += " +" + (count - 1);
    }
    return selectionString;
  }

  reset() {
    this.selectionChanged.emit([this._itemList[0]]);
  }

  chooseItem(item) {

    if(!item || item.key == null) {
      return;
    }

    if(this.isSelected(item)) {
      this.selectedItemsList = this.selectedItemsList.filter(el => el.key != item.key);
    }
    else {
      //if we have "all" selected
      if (this.selectedItemsList[0] && this._itemList[0] &&
        this.selectedItemsList[0].key == this._itemList[0].key) {
        this.selectedItemsList = [];
      }
      this.selectedItemsList.push(item);
    }

    //if we remove them all, it's as if all were selected
    if(this.selectedItemsList.length == 0) {
      this.reset();
    }
    else {
      this.selectionChanged.emit(this.selectedItemsList);
    }

  }

}

export class CustomMap {
  key: string;
  value: string;
}
